exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Layout {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .Layout--Sidebar .Layout__Content {\n    margin-left: 200px; }\n  .Layout__Sidebar {\n    height: 100%; }\n\n@media (max-width: 960px) {\n  .Layout--Sidebar .Layout__Content {\n    margin-left: 64px; } }\n\n@media (max-width: 500px) {\n  .Layout--Sidebar .Layout__Content {\n    margin-left: 0; }\n  .Layout .Section.Header {\n    padding: 104px 0 40px 0;\n    margin-bottom: 0; } }\n", ""]);

// exports
